import { Box, Stack, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import * as React from 'react';
import ImageBoxFuture from '../shared/image-box-future';

interface LocationCardProps {
  title: string | React.ReactNode;
  subtitle: string;
  cinemasCount?: number;
  img: string | File;
}

const LocationCard: FC<LocationCardProps> = ({ title, subtitle, cinemasCount, img }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Stack
      direction='row'
      spacing={2}
      sx={{
        alignItems: 'center',
      }}
    >
      <ImageBoxFuture
        img={img}
        title={intl.formatMessage({
          id: 'images.title.location',
        })}
        objectFit='contain'
        sx={{
          alignSelf: 'center',
          width: '48px',
          height: '48px',
        }}
      />
      <Box>
        <Typography
          component='div'
          sx={{
            fontFamily: 'co-head-line-corp-bold',
            color: theme.palette.common.black,
          }}
        >
          {title}
        </Typography>
        <Typography
          component='div'
          sx={{
            marginTop: pxToRem(4),
            fontSize: pxToRem(14),
            lineHeight: pxToRem(24),
            color: theme.palette.typography.color.muted,
          }}
        >
          {cinemasCount ?? null} <FormattedMessage id={subtitle} />
        </Typography>
      </Box>
    </Stack>
  );
};

export default LocationCard;
